import request from '@/utils/request'

// 用户登录
export function login(data) {
  return request({
    url: '/sdau/app/login',
    method: 'post',
    data
  })
}
// 第三方登录
export function otherLogin(data) {
  return request({
    url: `/api/oauth/render/${data}`,
    method: 'get',

  })
}

// 农大获取当前用户信息
export function sdauGetInfo(id) {
  return request({
    url: `/sdau/usermanage/student/${id}`,
    method: 'get',
  })
}
// 获取当前用户信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get',
  })
}

// 修改密码信息发送
export function updatePasswordMessage() {
  return request({
    url: '/api/oauth/updatePasswordMessage',
    method: 'Post',
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}

// 锁屏解锁登录
export function unlock(data) {
  return request({
    url: '/api/oauth/LockScreen',
    method: 'post',
    data
  })
}

// 获取默认配置
export function getConfig(account) {
  return request({
    url: `/api/oauth/getConfig/${account}`,
    method: 'get'
  })
}


